export default __webpack_public_path__ + "static/media/social.3c983749.svg";